import { render, staticRenderFns } from "./UrbanRenewalDetail.vue?vue&type=template&id=59aebf88"
import script from "./UrbanRenewalDetail.vue?vue&type=script&lang=js"
export * from "./UrbanRenewalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports